import React from "react";
import Modal from "react-modal";

const PortfolioModal = ({ open, toggle, portfolio }) => {
  return (
    <Modal
      isOpen={open}
      onRequestClose={toggle}
      contentLabel="My dialog"
      className="custom-modal"
      overlayClassName="custom-overlay"
      closeTimeoutMS={500}
    >
      <div className="beny_tm_modalbox_news">
        <button className="close-modal" onClick={toggle}>
          <img src="/img/svg/cancel.svg" alt="close icon" />
        </button>
        {/* End close modal */}
        <div className="box_inner">
          <div className="description_wrap scrollable">
            <div className="image">
              <img src={portfolio?.cover} alt="thumb" />
              <div
                className="main"
                style={{
                  backgroundImage: `url(${
                    process.env.PUBLIC_URL + portfolio?.cover
                  })`,
                }}
              ></div>
            </div>
            {/* End image */}

            <div className="details">
              <span>
                {portfolio?.timeline}{" "}
                {portfolio?.projectUrl && (
                  <a href={portfolio?.projectUrl}>Project Link</a>
                )}
                <a href="#">{portfolio?.team}</a>
              </span>
              <h3 className="title">{portfolio?.title}</h3>
            </div>
            {/* End details */}
            {portfolio?.description && (
              <div className="main_content">
                <div
                  className="descriptions"
                  dangerouslySetInnerHTML={{ __html: portfolio?.description }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PortfolioModal;
